//目前ws地址
export const websocketUrl = "";
//websocket端口
export const websocketPort = "9001";
//url前缀 测试
//export const baseUrl = "https://lx.sinowyde.com.cn";
//正式环境
export const baseUrl = "https://unineverefe.com";

export const prefix = "/platfrom";

export const nfsprefix = '/testnfs';